import { UploadIcon } from '@bp/ui-components';
import classNames from 'classnames';
import { BpFile } from 'components/Files/hooks/useFiles';
import { registerPlugin } from 'filepond';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import { ReactNode, useEffect, useRef, useState } from 'react';
import { renderToString } from 'react-dom/server';
import { FilePond } from 'react-filepond';
import { useTranslation } from 'react-i18next';
import { getTokens } from 'utils/authStore';
import styles from './FileUpload.module.scss';

registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

type FileUploadProps = {
  onFileUpload: (file: BpFile) => void;
  className?: string | undefined;
};

export const FileUpload = ({ onFileUpload, className }: FileUploadProps) => {
  const { t } = useTranslation();

  const [token, setToken] = useState<string | null>(null);
  const pondRef = useRef<FilePond>(null);

  useEffect(() => {
    getTokens().then((tokens) => {
      setToken(tokens?.access_token ?? null);
    });
  }, []);

  const UploadLabel: ReactNode = (
    <div className={classNames('filepond--label-action', styles['upload-label'])}>
      <UploadIcon className={styles.icon} />
      <div className={styles.instruction}>{t('files.uploadInstruction')}</div>
      <div className={styles.hint}>{t('files.maxFileSize')}</div>
    </div>
  );

  return (
    <div className={classNames(styles['file-upload'], className)}>
      <FilePond
        ref={pondRef}
        className={styles.filepond}
        onprocessfile={(error, file) => {
          if (!error && file.serverId) {
            const data = JSON.parse(file.serverId as string);
            onFileUpload({
              uuid: data.uuid,
              filename: data.filename,
              size: data.size,
              mediaType: data.mediaType,
              downloadToken: '',
              publicDownloadToken: null,
            });
            pondRef.current?.removeFile(file.id);
          }
        }}
        disabled={!token}
        allowMultiple
        instantUpload
        allowProcess
        dropOnPage
        maxParallelUploads={5}
        server={{
          process: {
            url: `${import.meta.env.VITE_APP_BACKEND_URI}${import.meta.env.VITE_APP_BACKEND_REST_PATH}/files`,
            headers: {
              Authorization: `Bearer ${token}`,
            },
            ondata: (fd: FormData) => {
              const file = fd.getAll('file');
              if (file[1]) {
                const filename = (file[1] as File).name;
                if (filename) {
                  fd.append('filename', filename);
                }
              }
              return fd;
            },
            onload: (response) => response,
          },
        }}
        name='file' //<-- Muss unbedingt so heissen!
        allowRevert={false}
        labelIdle={renderToString(UploadLabel)}
        credits={false}
      />
    </div>
  );
};
